import { createStructuredSelector } from "reselect";
import {
    DOSAGE_FORM_LIST,
    DOSAGE_FORM_LIST_SUCCESS,
    DOSAGE_FORM_LIST_ERROR,
    DOSAGE_FORM_PAGE_SET,
    DOSAGE_FORM_HEADER,
    DOSAGE_FORM_SEARCH_SET,
    DOSAGE_FORM_SEARCH_CHANGE,
    DOSAGE_FORM_ADD_SET,
    DOSAGE_FORM_ADD_MODAL_SET,
    DOSAGE_FORM_ADD,
    DOSAGE_FORM_ADD_SUCCESS,
    DOSAGE_FORM_ADD_ERROR,
    DOSAGE_FORM_ADD_CHANGE,
    DOSAGE_FORM_EDIT_SET,
    DOSAGE_FORM_EDIT_CHANGE,
    DOSAGE_FORM_EDIT_MODAL_SET,
    DOSAGE_FORM_DETAIL,
    DOSAGE_FORM_DETAIL_SUCCESS,
    DOSAGE_FORM_DETAIL_ERROR,
    DOSAGE_FORM_UPDATE,
    DOSAGE_FORM_UPDATE_SUCCESS,
    DOSAGE_FORM_UPDATE_ERROR
} from "../actions";

export const NAME = 'dosageForm';

export const DosageFormList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: DOSAGE_FORM_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DosageFormListSuccess = (data) => ({
    type: DOSAGE_FORM_LIST_SUCCESS,
    payload: data
});

export const DosageFormListError = (error) => ({
    type: DOSAGE_FORM_LIST_ERROR,
    payload: error
});

export const DosageFormPageSet = (data) => ({
    type: DOSAGE_FORM_PAGE_SET,
    payload: data
});

export const DosageFormHeader = (data) => ({
    type: DOSAGE_FORM_HEADER,
    payload: data
})

export const DosageFormSearchSet = (data) => ({
    type: DOSAGE_FORM_SEARCH_SET,
    payload: data
});

export const DosageFormSearchChangeSet = (data) => ({
    type: DOSAGE_FORM_SEARCH_CHANGE,
    payload: data
});


export const DosageFormAddChangeSet = (data) => ({
    type: DOSAGE_FORM_ADD_CHANGE,
    payload: data
});

export const DosageFormAddSet = (data) => ({
    type: DOSAGE_FORM_ADD_SET,
    payload: data
});

export const DosageFormAddModalSet = (data) => ({
    type: DOSAGE_FORM_ADD_MODAL_SET,
    payload: data
});

export const DosageFormAdd = (data) => ({
    type: DOSAGE_FORM_ADD,
    payload: data
});

export const DosageFormAddSuccess = (message) => ({
    type: DOSAGE_FORM_ADD_SUCCESS,
    payload: message
});

export const DosageFormAddError = (error) => ({
    type: DOSAGE_FORM_ADD_ERROR,
    payload: error
});

export const DosageFormEditSet = (data) => ({
    type: DOSAGE_FORM_EDIT_SET,
    payload: data
});

export const DosageFormEditChangeSet = (data) => ({
    type: DOSAGE_FORM_EDIT_CHANGE,
    payload: data
});

export const DosageFormEditModalSet = (data) => ({
    type: DOSAGE_FORM_EDIT_MODAL_SET,
    payload: data
});

export const DosageFormEditTabSet = (data) => ({
    type: DOSAGE_FORM_EDIT_TAB_SET,
    payload: data
});

export const DosageFormDetail = (data) => ({
    type: DOSAGE_FORM_DETAIL,
    payload: data
});

export const DosageFormDetailSuccess = (data) => ({
    type: DOSAGE_FORM_DETAIL_SUCCESS,
    payload: data
});

export const DosageFormDetailError = (error) => ({
    type: DOSAGE_FORM_DETAIL_ERROR,
    payload: error
});

export const DosageFormUpdate = (data) => ({
    type: DOSAGE_FORM_UPDATE,
    payload: data
});

export const DosageFormUpdateSuccess = (message) => ({
    type: DOSAGE_FORM_UPDATE_SUCCESS,
    payload: message
});

export const DosageFormUpdateError = (error) => ({
    type: DOSAGE_FORM_UPDATE_ERROR,
    payload: error
});



const dosageForm = (state) => state[NAME];

export const DosageFormSelector = createStructuredSelector({
    dosageForm
})
